import React from "react";
import "./AgentCarriers.css";

const carriers = [
  "1.png",
  "2.png",
  "3.png",
  "4.png",
  "5.png",
  "6.png",
  "7.png",
  "8.png",
  "9.png",
  "10.png",
  "11.png",
  "12.png",
  "13.png",
  "14.png",
  "15.png",
  "16.png",
  "17.png",
  "18.png",
  "19.png",
  "20.png",
  "21.png",
  "22.png",
  "23.png",
  "24.png",
  "25.png",
  "26.png",
  "27.png",
  "28.png",
];

function AgentCarriers() {
  return (
    <section className="agent-carriers-page">
      <div className="agent-carriers-container">
        <h1>Carriers that I trust and work with.</h1>
        <p className="agent-carriers-subtitle">
          I work with leading insurance providers nationwide to bring you the
          best options available.
        </p>
        <div className="agent-carriers-grid">
          {carriers.map((logo, index) => (
            <div className="agent-carrier-logo" key={index}>
              <img
                src={`/images/carriers/${logo}`}
                alt={logo.replace(".png", "")}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AgentCarriers;
